import TransferOverlayItem from './Components/TransferOverlayItem'
import useTransferOverlayTasks from './Hooks/useTransferOverlayTasks'

export default function TransferOverlay() {
    const { state, handler } = useTransferOverlayTasks()
    const visibleTasks = state.tasks.slice(-3)

    if (visibleTasks.length === 0) {
        return null
    }

    return (
        <div className="fixed right-4 bottom-4 z-[110] flex max-h-[calc(100vh-2rem)] flex-col gap-3 overflow-y-auto pr-1">
            {visibleTasks.map((task) => (
                <TransferOverlayItem
                    key={task.id}
                    task={task}
                    onDismiss={handler.handleDismissTask}
                />
            ))}
        </div>
    )
}
